import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=6780efa8&scoped=true&"
import script from "./ActivityTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./ActivityTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ActivityTable.vue?vue&type=style&index=0&id=6780efa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6780efa8",
  null
  
)

export default component.exports